/**
 * @generated SignedSource<<7da5a0cc59e307e949d5c921ecd41a2b>>
 * @relayHash ae8c0df8b458c191f8dbdc3067c4d451
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f5629fcf1f358b362aa590d439d2c0b3b1226aeff22ab5c3341f879647bc9d2c

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceAppInstallationLicenseCapabilitySet = "CAPABILITY_ADVANCED" | "CAPABILITY_STANDARD" | "%future added value";
export type ConfluenceExtensionVisibilityControlMechanism = "APP_ACCESS_RULES" | "DISPLAY_CONDITIONS" | "%future added value";
export type ConfluenceExtensionRenderingContextInput = {
  attachmentId?: string | null;
  contentId?: AGG$Long | null;
  spaceId?: AGG$Long | null;
  spaceKey?: string | null;
};
export type usePrefilteredExtensionList_forge_ui_Query$variables = {
  cloudId: string;
  context?: ConfluenceExtensionRenderingContextInput | null;
  includeHidden?: boolean | null;
  locale?: string | null;
  types?: ReadonlyArray<string | null> | null;
};
export type usePrefilteredExtensionList_forge_ui_Query$data = {
  readonly confluence_forgeExtensionsByType: ReadonlyArray<{
    readonly appId: string;
    readonly appOwner: string | null;
    readonly appVersion: string | null;
    readonly consentUrl: string | null;
    readonly egress: ReadonlyArray<{
      readonly addresses: ReadonlyArray<string | null> | null;
      readonly category: string | null;
      readonly inScopeEUD: boolean | null;
      readonly type: string | null;
    }> | null;
    readonly environmentId: string;
    readonly environmentKey: string | null;
    readonly environmentType: string;
    readonly hiddenBy: ConfluenceExtensionVisibilityControlMechanism | null;
    readonly id: string;
    readonly installationId: string;
    readonly key: string;
    readonly license: {
      readonly active: boolean;
      readonly billingPeriod: string | null;
      readonly capabilitySet: ConfluenceAppInstallationLicenseCapabilitySet | null;
      readonly ccpEntitlementId: string | null;
      readonly ccpEntitlementSlug: string | null;
      readonly isEvaluation: boolean | null;
      readonly subscriptionEndDate: string | null;
      readonly trialEndDate: string | null;
      readonly type: string | null;
    } | null;
    readonly migrationKey: string | null;
    readonly properties: ReadonlyArray<{
      readonly key: string | null;
      readonly value: string | null;
    }>;
    readonly remoteInstallationRegion: string | null;
    readonly sandboxPolicies: ReadonlyArray<string> | null;
    readonly scopes: ReadonlyArray<string | null>;
    readonly type: string;
    readonly userAccess: {
      readonly enabled: boolean | null;
      readonly hasAccess: boolean | null;
    } | null;
  } | null> | null;
};
export type usePrefilteredExtensionList_forge_ui_Query = {
  response: usePrefilteredExtensionList_forge_ui_Query$data;
  variables: usePrefilteredExtensionList_forge_ui_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "context"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeHidden"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locale"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "types"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "key"
},
v2 = {
  "kind": "ScalarField",
  "name": "type"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "context",
        "variableName": "context"
      },
      {
        "kind": "Variable",
        "name": "includeHidden",
        "variableName": "includeHidden"
      },
      {
        "kind": "Variable",
        "name": "locale",
        "variableName": "locale"
      },
      {
        "kind": "Variable",
        "name": "types",
        "variableName": "types"
      }
    ],
    "concreteType": "ConfluenceForgeExtension",
    "kind": "LinkedField",
    "name": "confluence_forgeExtensionsByType",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "appId"
      },
      {
        "kind": "ScalarField",
        "name": "appVersion"
      },
      {
        "kind": "ScalarField",
        "name": "appOwner"
      },
      {
        "kind": "ScalarField",
        "name": "environmentId"
      },
      {
        "kind": "ScalarField",
        "name": "environmentType"
      },
      {
        "kind": "ScalarField",
        "name": "environmentKey"
      },
      {
        "kind": "ScalarField",
        "name": "consentUrl"
      },
      {
        "kind": "ScalarField",
        "name": "migrationKey"
      },
      {
        "concreteType": "ConfluenceUserAccess",
        "kind": "LinkedField",
        "name": "userAccess",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "enabled"
          },
          {
            "kind": "ScalarField",
            "name": "hasAccess"
          }
        ]
      },
      (v1/*: any*/),
      {
        "concreteType": "KeyValueHierarchyMap",
        "kind": "LinkedField",
        "name": "properties",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "value"
          }
        ]
      },
      {
        "concreteType": "ConfluenceExtensionEgressDeclaration",
        "kind": "LinkedField",
        "name": "egress",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "addresses"
          },
          {
            "kind": "ScalarField",
            "name": "category"
          },
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "inScopeEUD"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "sandboxPolicies"
      },
      {
        "kind": "ScalarField",
        "name": "scopes"
      },
      {
        "concreteType": "ConfluenceAppInstallationLicense",
        "kind": "LinkedField",
        "name": "license",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "active"
          },
          {
            "kind": "ScalarField",
            "name": "capabilitySet"
          },
          {
            "kind": "ScalarField",
            "name": "billingPeriod"
          },
          {
            "kind": "ScalarField",
            "name": "ccpEntitlementId"
          },
          {
            "kind": "ScalarField",
            "name": "ccpEntitlementSlug"
          },
          {
            "kind": "ScalarField",
            "name": "isEvaluation"
          },
          {
            "kind": "ScalarField",
            "name": "subscriptionEndDate"
          },
          {
            "kind": "ScalarField",
            "name": "trialEndDate"
          },
          (v2/*: any*/)
        ]
      },
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "name": "installationId"
      },
      {
        "kind": "ScalarField",
        "name": "remoteInstallationRegion"
      },
      {
        "kind": "ScalarField",
        "name": "hiddenBy"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "usePrefilteredExtensionList_forge_ui_Query",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePrefilteredExtensionList_forge_ui_Query",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "f5629fcf1f358b362aa590d439d2c0b3b1226aeff22ab5c3341f879647bc9d2c",
    "metadata": {},
    "name": "usePrefilteredExtensionList_forge_ui_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9988fba56919e313afdb928b7bdb852d";

export default node;
